import React, { createContext, useContext, useMemo } from 'react'
import { useGroupLimits as useGroupLimitsService } from '../services/getGroupLimits'

const GroupLimitsContext = createContext()

export const useGroupLimits = () => {
  const context = useContext(GroupLimitsContext)
  if (!context) throw new Error('You need to use the GroupLimitsProvider to use the useGroupLimits')
  return context
}

export default function GroupLimitsProvider({ children }) {
  const [{ data, loading }] = useGroupLimitsService()
  const value = useMemo(() => ({ ...data, loading }), [data, loading])
  return <GroupLimitsContext.Provider value={value}>{children}</GroupLimitsContext.Provider>
}
